import Decision from "slotworks/state-machine/decisions/decision";
import State from "slotworks/state-machine/states/state";
abstract class StateRegister {

    public static add(id: string, concrete: State | Decision) {
        this.concretes.set(id, concrete);
    }

    public static get(id: string): State | Decision {
        if (!this.concretes.has(id)) {
            throw new Error("Missing concrete for state machine :: Could not find `" + id + "`");
        }
        return this.concretes.get(id);
    }

    private static concretes: Map<string, (State | Decision)> = new Map<string, (State | Decision)>();

}

export default StateRegister;



// WEBPACK FOOTER //
// ./~/ifdef-loader/ifdef-loader.js??ref--0-1!./~/slotworks/state-machine/state-register.ts